import React from 'react'

import { FormFieldSubmitType } from '../builders/FormBuilder'
import {
  getPuxButtonClasses,
  PuxButtonSize,
  PuxButtonTheme,
  PuxButtonVariant,
} from '../PuxButton/PuxButton'
import { WidgetProperitesPart } from '../builders/WidgetBuilder'
import { getClass, replaceResourceStrings } from './formFieldHelper'
import PuxIcon from '../PuxIcon/PuxIcon'

const FormFieldSubmitWidget: React.FC<{
  props: FormFieldSubmitType
  widgetProperties?: WidgetProperitesPart
}> = ({ props, widgetProperties }) => {
  // const classes = getPuxButtonClasses({
  //   buttonType: props.buttonType as PuxButtonVariant,
  //   buttonTheme: props.buttonTheme as PuxButtonTheme,
  //   buttonSize: props.buttonSize as PuxButtonSize,
  // })

  return (
    <div
      className={`FormGroup${getClass(
        props?.metadata?.size,
        widgetProperties
      )} FormGroup--submit`}
    >
      <button
        type='submit'
        // className={classes.join(` `)}
        className={`Button Button--primary Button--lg`}
      >
        {replaceResourceStrings(props?.formElementName)}
        <PuxIcon name={'arrows/arrow-right'} size={24} decorative={true} />
      </button>
    </div>
  )
}

export default FormFieldSubmitWidget
